//https://github.com/reduxjs/redux#redux-toolkit-example
import { configureStore, createSlice } from '@reduxjs/toolkit'

const regionSlice = createSlice({
    name: 'region',
    initialState: {
        list: {},
        checked: {}
    },
    reducers: {
        set_region: (state, { payload }) => {
            state = payload;
            return { ...state }
        },
        set_checked: (state, { payload }) => {
            state.checked = payload.checked
        },
        set_list: (state, { payload }) => {
            state.list = payload.regionList
        }
    }
})


const pageSlice = createSlice({
    name: 'page',
    initialState: {},
    reducers: {
        set_page: (state, { payload }) => {
            state = payload;
            return { ...state }
        }
    }
})


export const { set_region, set_checked, set_list } = regionSlice.actions
export const { set_page } = pageSlice.actions

export default configureStore({
    reducer: {
        region: regionSlice.reducer,
        page: pageSlice.reducer
    }
});